import React, { Fragment } from 'react'
import { NoteContainer } from './styled'

const Note = (props) => {
  const { vendorCode, submittedDate, companyName, documentNumber, billingContactEmail, companyTextInfo, noteTh, noteEn } = props
  const language = vendorCode.startsWith('3') ? 'en' : 'th'

  const monthTxt = {
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ], 
    th: [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม',
      'มกราคม'
    ]
  }
  
  const billingDate = (date) => {
    if (date.getDate() > 24) {
      date.setDate(24)
      date.setMonth(date.getMonth() + 1)
    } 
    return date
  }
  
  const getYear = (date) => {
    var year = date.getFullYear()
    if (language === 'th') {
      return year < 2500 ? year + 543 : year
    } else {
      return year > 2500 ? year - 543 : year
    }
  }
  
  const getBillingCycleMonth = () => {
    var blDate = billingDate(submittedDate)
    return `${monthTxt[language][blDate.getMonth()]} ${getYear(blDate)}`
  }

  const getBillingNoteMessage = () => {
    const message = {
      en: 
        <Fragment>
          <b>Note</b><br />
          <ul style={{ margin: '5px 0px', paddingLeft: '30px' }}>
            <div dangerouslySetInnerHTML={{__html: noteEn}}/>
          </ul>
        </Fragment>,
      th: 
        <Fragment>
          <b>Note</b><br />
          <ul style={{ margin: '5px 0px', paddingLeft: '30px' }}>
            <li>
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ color: 'red', fontWeight: 'bold', marginRight: '5px' }}>{documentNumber}</div>
                รอบวางบิลเดือน
                <div style={{ color: 'red', textDecoration: 'underline', fontWeight: 'bold', marginLeft: '5px', marginRight: '5px' }}>{getBillingCycleMonth()}</div>
                กรุณานำส่งเอกสารประกอบการวางบิลมาถึง {companyName} ภายในวันที่
                <div style={{ color: 'red', textDecoration: 'underline', fontWeight: 'bold', marginLeft: '5px', marginRight: '5px' }}>24 {getBillingCycleMonth()}</div>
                กรณีที่บริษัทได้รับเอกสารหลังวันที่กำหนดหรือเอกสารไม่ครบถ้วน บริษัทขอสงวนสิทธิ์จัดเป็นรอบการวางบิลของเดือนถัดไป
              </div>
            </li>
            <div dangerouslySetInnerHTML={{__html: noteTh}}/>
            <li>{companyTextInfo}</li>
          </ul>
        </Fragment>
    }

    return message[language]
  }

  return (
    <NoteContainer>
      <span style={{ paddingLeft: '10px' }}>
        {getBillingNoteMessage()}
      </span> 
    </NoteContainer>
  )
}

export default Note